import { useState } from 'react';
import { FAILURE_CATEGORIES } from './constants';

interface FailureModalProps {
  readonly onConfirm: (category: string, notes: string) => void;
  readonly onClose: () => void;
  readonly isPending: boolean;
}

export const FailureModal = ({ onConfirm, onClose, isPending }: FailureModalProps) => {
  const [category, setCategory] = useState('');
  const [notes, setNotes] = useState('');

  const handleConfirm = () => {
    if (!category || !notes.trim()) return;
    onConfirm(category, notes.trim());
  };

  return (
    <div
      onClick={onClose}
      style={{
        position: 'fixed',
        inset: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.4)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 1000,
      }}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          backgroundColor: 'var(--bg-surface)',
          borderRadius: 'var(--radius-lg)',
          padding: '20px 24px',
          width: '360px',
          maxWidth: '90%',
          boxShadow: 'var(--shadow-lg)',
        }}
      >
        <h3
          style={{
            fontSize: '16px',
            fontWeight: 'var(--font-weight-medium)',
            color: 'var(--text-primary)',
            marginBottom: '4px',
          }}
        >
          Mark as failed
        </h3>
        <p
          style={{
            fontSize: '13px',
            color: 'var(--text-secondary)',
            marginBottom: '14px',
          }}
        >
          Record a print failure for this order. The order can be re-queued after.
        </p>

        {/* Category dropdown */}
        <select
          value={category}
          onChange={(e) => setCategory(e.target.value)}
          className="admin-input"
          style={{ width: '100%', marginBottom: '8px', fontSize: '13px' }}
        >
          <option value="">Select failure category...</option>
          {FAILURE_CATEGORIES.map((c) => (
            <option key={c} value={c}>{c}</option>
          ))}
        </select>

        {/* Notes */}
        <textarea
          value={notes}
          onChange={(e) => setNotes(e.target.value)}
          placeholder="What went wrong?"
          className="admin-input"
          style={{ width: '100%', minHeight: '70px', fontSize: '13px', resize: 'vertical', marginBottom: '12px' }}
        />

        {/* Footer */}
        <div className="flex justify-end" style={{ gap: '8px' }}>
          <button
            onClick={onClose}
            style={{
              fontSize: '13px',
              padding: '7px 16px',
              minHeight: '44px',
              borderRadius: 'var(--radius-md)',
              border: '0.5px solid var(--border-default)',
              backgroundColor: 'transparent',
              color: 'var(--text-secondary)',
              cursor: 'pointer',
            }}
          >
            Go back
          </button>
          <button
            onClick={handleConfirm}
            disabled={!category || !notes.trim() || isPending}
            style={{
              fontSize: '13px',
              padding: '7px 16px',
              minHeight: '44px',
              borderRadius: 'var(--radius-md)',
              border: 'none',
              backgroundColor: 'var(--bg-error-subtle)',
              color: 'var(--color-error-600)',
              fontWeight: 'var(--font-weight-medium)',
              cursor: !category || !notes.trim() || isPending ? 'not-allowed' : 'pointer',
              opacity: !category || !notes.trim() || isPending ? 0.6 : 1,
            }}
          >
            {isPending ? 'Processing...' : 'Mark failed'}
          </button>
        </div>
      </div>
    </div>
  );
};
